<template>
  <div>
    <div
      v-if="hotel && hotel.hasAvailableStays() && filteredHotel"
      :class="isWebRedesign ? 'rd-view__topbar rhg-py-0' : 'rd-view__topbar'"
    >
      <div
        :class="
          isWebRedesign
            ? 'rd-view__topbar-filters rhg-m-width rhg-pt-0 rhg-pb-0'
            : 'rd-view__topbar-filters'
        "
      >
        <FilterComponent
          :filter="filter"
          :isFirstRoom="selectedRoom === 1"
          :showNumberOfMatches="true"
          :showBreakfast="selectedRoom === 1"
          :selectedRoomCode="selectedRoomCode"
          :numberOfRoomsLeftByRoomId="numberOfRoomsLeftByRoomId"
          @select="onSelectFilter"
          @unselect="onUnselectFilter"
          @clear="onClearFilter"
        />
      </div>
    </div>

    <div v-if="hotel && hasNotificationMessages(hotel.notificationMessages)" class="rd-view__info">
      <InfoHotelComponent :messages="hotel.notificationMessages" />
    </div>
    <NextTierMessageVue
      v-if="showTierMessage && !isNewCorporateProgramActive && !tierDashboardFFActive"
    />
    <NewNextTierMessage
      v-if="showTierMessage && !isNewCorporateProgramActive && tierDashboardFFActive"
    />
    <div
      v-if="filter && filter.hasAnyPreselectedFilterWithZeroMatches && filter.options.selected"
      class="rd-view__preselected-filter-not-matches"
    >
      <PreselectedFilterNotMatches />
    </div>
    <div
      v-if="filteredHotel && specialSearchTypeIsNotApplied()"
      class="rd-view__invalid-special-search-type"
    >
      <InvalidSpecialSearchType
        :label="labelForInvalidSpecialSearchType()"
        @checkAvailability="onCheckHotelAvailability"
        :hotel="hotel"
      />
    </div>
    <div
      v-if="pacCodeSearchTypeIsNotAvailableDates() || pacCodeSearchTypeIsNotApplied()"
      class="rd-view__invalid-pac-search-type-dates"
    >
      <InvalidPacSearchTypeDates
        @checkAvailability="onCheckHotelAvailability"
        :label="searchTypeErrorMessage"
        :hotel="hotel"
      />
    </div>
    <div
      v-if="shouldShowPacSearchTypeInfo"
      :class="
        isWebRedesign
          ? 'rd-view__info-pac-search-type rhg-m-width rhg-my-0 rhg-rd-p-0'
          : 'rd-view__info-pac-search-type'
      "
    >
      <InfoPacSearchType :isLoading="isLoading" @clickedCTA="onViewAllStays" />
    </div>
    <RoomTabs
      v-if="!isMobile && rooms > 1 && hotel && hotel.hasAvailableStays() && !hotel.isExternal"
      :numRooms="rooms"
      :selectedRates="selectedRates"
      :changeTab.sync="selectedRoomChange"
      :hasRateAndMealPlanSelected="hasRateAndMealPlanSelected"
      :lastRoomSelected="selectedRates.length + 1"
      v-model="selectedRoom"
    />
    <div
      v-show="!isMobile && blackoutText"
      class="rd-view__banners rd-view__main-content rhg-m-width rhg-my-0r"
    >
      <BlackoutBanner :text="blackoutText" />
    </div>

    <div
      v-if="!isMobile && rooms > 1 && hotel && hotel.hasAvailableStays() && !hotel.isExternal"
      class="rd-view__banners rd-view__main-content rhg-m-width rhg-my-0r"
    >
      <OccupancyByRoomBanner :currentRoom="selectedRoom" :occupancyByRooms="occupancyByRooms" />
      <RateMealPlanBanner
        :mealPlanName="mealPlanName"
        :rateName="rateName"
        :currentRoom="selectedRoom"
        @update-room="updateCurrentRoom"
      />
    </div>
    <div
      :class="
        isWebRedesign
          ? 'rd-view__main-content rhg-m-width rhg-my-0'
          : 'rd-view__main-content rhg-m-width rhg-my-0'
      "
      key="NaN"
    >
      <div class="rd-view__left-side">
        <div v-if="!isHotelDataFullyLoaded">
          <HotelSkeleton />
        </div>
        <div v-else>
          <HotelCardComponent
            class="rd-view__hotel-card"
            :hotel="hotel"
            :tripAdvisorInfo="tripAdvisorHotelInfo"
            :customerCrowd="customer.crowd"
          />
          <MembersBenefits :benefits="getMembersBenefits" v-if="shouldShowBenefits" />
          <RoomTabs
            v-if="isMobile && rooms > 1 && hotel && hotel.hasAvailableStays() && !hotel.isExternal"
            :numRooms="rooms"
            :selectedRates="selectedRates"
            :changeTab.sync="selectedRoomChange"
            :hasRateAndMealPlanSelected="hasRateAndMealPlanSelected"
            :lastRoomSelected="selectedRates.length + 1"
            v-model="selectedRoom"
          />
          <BlackoutBanner v-if="isMobile && blackoutText" class="rhg-mb-8" :text="blackoutText" />
          <OccupancyByRoomBanner
            v-if="isMobile && rooms > 1 && hotel && hotel.hasAvailableStays() && !hotel.isExternal"
            :currentRoom="selectedRoom"
            :occupancyByRooms="occupancyByRooms"
          />
          <RateMealPlanBanner
            v-if="isMobile && rooms > 1 && hotel && hotel.hasAvailableStays() && !hotel.isExternal"
            :mealPlanName="mealPlanName"
            :rateName="rateName"
            :currentRoom="selectedRoom"
            @update-room="updateCurrentRoom"
          />

          <TripAdvisor
            v-if="tripAdvisorHotelInfo && tripAdvisorHotelInfo.hasReviews"
            class="rd-view__tripadvisor"
            :info="tripAdvisorHotelInfo"
          />
        </div>
      </div>
      <div class="rd-view__right-side">
        <div v-if="staysHasBeenLoading">
          <template>
            <RoomSkeleton />
            <RoomSkeleton />
          </template>
        </div>
        <div
          v-else-if="hotel && !hotel.hasAvailableStays() && !hotel.isExternal"
          class="rd-view__no-availability-dates"
        >
          <NoAvailabilityDates
            :hotel="hotel"
            :isMinNightsStay="isMinLOS()"
            @checkAvailability="onCheckHotelAvailability"
          />
        </div>
        <div v-else-if="hotel && hotel.isExternal" class="rd-view__no-availability-dates">
          <ExternalBookingRooms :externalHotelInfo="hotel.externalHotelInfo"></ExternalBookingRooms>
        </div>
        <div v-else-if="filteredHotel && filteredHotel.hasAvailableStays() && !hotel.isExternal">
          <VipMessageBreakfast v-if="isTierVip" />
          <div class="rd-view__room-cards" v-for="(room, index) in orderedFilterRoom" :key="index">
            <RoomComponent
              v-if="
                room &&
                ((isRoomSoldOut.includes(room.id) && isSelectedRoom(room)) ||
                  !isRoomSoldOut.includes(room.id))
              "
              class="rd-view__room-card"
              :taxIncludedRegion="taxIncludedRegion"
              :loyaltyConsentAccepted="loyaltyConsentAccepted"
              :room="room"
              :key="selectedRoom"
              :hotelCode="hotel.code"
              :style="getAnimationStyle(index)"
              :hotelName="hotel.name"
              :customer="customer"
              :isLastRoomTab="isLastRoomTab"
              :bookingStayInProgress="bookingStayInProgress"
              :currentRoom="selectedRoom"
              :isFirstRoom="selectedRoom === 1"
              :rooms="selectedRates"
              :nRooms="rooms"
              @selectStay="onSelectStay($event)"
              @roomSelected="handleRoomSelected"
              :remainingRooms="
                numberOfRoomsLeftByRoomId?.find(item => item?.id === room.id)?.numberOfRoomsLeft
              "
            />
          </div>
        </div>
        <div
          v-if="
            !staysHasBeenLoading &&
            filteredHotel &&
            !filteredHotel.hasAvailableStays() &&
            hotel.hasAvailableStays()
          "
        >
          <FilterNotMatchesComponent @clearFilter="onClearFilter" />
        </div>
        <div
          v-if="
            !staysHasBeenLoading && filteredHotel && nearbyHotels.length > 0 && !hotel.isExternal
          "
          class="rd-view__nearby-hotels"
        >
          <NearbyHotelsComponent
            :hotels="nearbyHotels"
            :showExpandedByDefault="!hotel.hasAvailableStays()"
            @checkAvailability="onCheckHotelAvailability"
          />
        </div>
      </div>
    </div>
    <div
      v-if="hotel && hotel.hasAvailableStays() && filteredHotel && filter"
      class="rd-view__fixed-bar"
    >
      <FixedBar
        :customer="customer"
        :filter="filter"
        :hotel="hotel"
        :isFirstRoom="selectedRoom === 1"
        :showBreakfast="selectedRoom === 1"
        @changeFilter="onChangeFilter"
        :selectedRoomCode="selectedRoomCode"
        :numberOfRoomsLeftByRoomId="numberOfRoomsLeftByRoomId"
      />
    </div>
    <NotTravelAgentModal
      id="not-travel-agent-modal"
      v-if="labelsLoaded"
      :content="content"
      :buttonText="buttonText"
    />
    <NonLoggedModal v-if="labelsLoaded" />
    <ErrorModal v-if="error" :error="error" />
    <InsufficientPointsModal v-if="labelsLoaded" @accept="onInsufficientPointsModalAccept()" />
    <LoyaltyConsentModal v-if="labelsLoaded" @signIn="onSignIn" @bookAndJoin="onBookAndJoin" />
  </div>
</template>

<script>
import { createNamespacedHelpers, mapGetters as mapGettersGeneral } from 'vuex'
import actions from './store/actions'
import HotelCardComponent from './components/hotel/HotelCardComponent'
import InfoHotelComponent from './components/hotel/InfoHotelComponent'
import RoomComponent from './components/room/RoomComponent'
import RoomSkeleton from './components/skeleton/RoomSkeleton'
import HotelSkeleton from './components/skeleton/HotelSkeleton.vue'
import FixedBar from './components/fixedBar/FixedBar'
import FilterNotMatchesComponent from './components/FilterNotMatchesError'
import NearbyHotelsComponent from './components/nearbyHotel/NearbyHotelsComponent'
import NonLoggedModal from '../components/NonLoggedModal'
import LoyaltyConsentModal from './components/modal/LoyaltyConsentModal'
import TripAdvisor from './components/tripadvisor/TripAdvisor'
import NoAvailabilityDates from './components/room/NoAvailabilityDates'
import InvalidSpecialSearchType from './components/room/InvalidSpecialSearchType'
import InvalidPacSearchTypeDates from './components/room/InvalidPacSearchTypeDates'
import ExternalStorage from '@/services/ExternalStorage'
import ErrorModal from '../components/ErrorModal'
import NotTravelAgentModal from '../components/NotTravelAgentModal'
import InsufficientPointsModal from './components/modal/InsufficientPointsModal'
import PreselectedFilterNotMatches from './components/room/PreselectedFilterNotMatches'
import { checkDate } from '@/services/SearchParamsValidator'
import { getQueryParams, isMinNightsStay, isMobileDevice } from '@/infrastructure/Utils'
import SearchTypes from '@/domain/SearchTypes'
import MembersBenefits from './components/rewardsBenefits/MembersBenefits.vue'
import NextTierMessageVue from './components/shared/NextTierMessage.vue'
import FilterComponent from '@/multi-room-display/components/filter/FilterComponent'
import ExternalBookingRooms from '../components/ExternalBookingRooms'
import InfoPacSearchType from './components/room/InfoPacSearchType'
import { bookingService } from '@/multi-room-display/infrastructure/Factory'
import VipMessageBreakfast from '@/multi-room-display/components/room/VipMessageBreakfast'
import RoomTabs from './components/roomTabs/RoomTabs.vue'
import RateMealPlanBanner from './components/rateMealPlanBanner/RateMealPlanBanner.vue'
import OccupancyByRoomBanner from '@/multi-room-display/components/OccupancyByRoomBanner/OccupancyByRoomBanner.vue'
import { blackoutLabelFromMemberType } from '@/infrastructure/Blackout'
import BlackoutBanner from './components/BlackoutBanner/BlackoutBanner.vue'

const { mapActions, mapGetters, mapState } = createNamespacedHelpers('multiRoomDisplay')

export default {
  name: 'RoomDisplayView',
  components: {
    FilterComponent,
    PreselectedFilterNotMatches,
    NearbyHotelsComponent,
    FilterNotMatchesComponent,
    HotelCardComponent,
    InfoHotelComponent,
    RoomComponent,
    RoomSkeleton,
    HotelSkeleton,
    FixedBar,
    NonLoggedModal,
    InsufficientPointsModal,
    LoyaltyConsentModal,
    TripAdvisor,
    NoAvailabilityDates,
    InvalidSpecialSearchType,
    InvalidPacSearchTypeDates,
    ErrorModal,
    NotTravelAgentModal,
    MembersBenefits,
    NextTierMessageVue,
    ExternalBookingRooms,
    InfoPacSearchType,
    VipMessageBreakfast,
    RoomTabs,
    RateMealPlanBanner,
    OccupancyByRoomBanner,
    BlackoutBanner,
    NewNextTierMessage: () => import('./components/shared/NewNextTierMessage.vue')
  },
  data: () => ({
    hotelDiscount: 0,
    isPayAtProperty: false,
    roomsFilteredBySelection: null,
    changeCurrencyWidget: false,
    content: '',
    mealPlanSelected: '',
    rateSelected: '',
    buttonText: '',
    isLoading: false,
    selectedRoom: 1,
    selectedId: null,
    selectedRoomChange: false,
    isFirstLoad: true,
    selectedRates: [],
    hasRateAndMealPlanSelected: false,
    isMobile: isMobileDevice(),
    mealPlanName: '',
    rateName: '',
    tierDashboardFFActive: global.ConfigDynamic.isEnabled(
      global.configDynamicKey.TIER_DASHBOARD_ENABLED
    ),
    blackoutText: ''
  }),
  computed: {
    ...mapGetters([
      'hotel',
      'nearbyHotels',
      'bookingStayInProgress',
      'customer',
      'staysHasBeenLoading',
      'exchangeRates',
      'tripAdvisorHotelInfo',
      'labelsLoaded',
      'loyaltyConsentAccepted',
      'taxIncludedRegion',
      'filter',
      'filteredHotel',
      'error',
      'getMembersBenefits'
    ]),
    ...mapGettersGeneral(['isNewCorporateProgramActive']),
    ...mapState([
      'rooms',
      'occupancyByRooms',
      'numberOfRoomsLeftByRoomId',
      'initialNumberOfRoomsLeftByRoomId',
      'selectedRoomCode'
    ]),
    shouldShowBenefits() {
      return this.getMembersBenefits?.benefits.length && !this.customer.isLogged
    },
    isHotelDataFullyLoaded() {
      return this.hotel && this.getMembersBenefits?.benefits
    },
    showTierMessage() {
      const tierInfo = this.customer.tierInfo
      if (!tierInfo) return false

      const needsToUpgrade = tierInfo.stays.needToUp || tierInfo.nights.needToUp
      const isCloseToUpgrade = tierInfo.stays.closeToUp || tierInfo.nights.closeToUp

      return needsToUpgrade && isCloseToUpgrade
    },
    searchTypeErrorMessage() {
      return this.pacCodeSearchTypeIsNotAvailableDates()
        ? this.translate('rdSpecialRateValidNotAvailable')
        : this.translate('rdInvalidPacSearchTypeDates')
    },
    isTierVip() {
      return this.hotel?.freeUpgradeBB
    },
    getSelectedRoom() {
      return this.getRoomsBySelectedRoom(this.selectedRoom, this.filteredHotel.rooms)
    },
    isLastRoomTab() {
      const isLastTab = this.selectedRoom === this.rooms
      return isLastTab
    },
    isRoomSoldOut() {
      return this.numberOfRoomsLeftByRoomId
        .filter(room => room.numberOfRoomsLeft === 0)
        .map(room => room.id)
    },
    orderedFilterRoom() {
      const currentlySelectedRoom = this.selectedRates[this.selectedRoom - 1]?.code
      return (this.filteredHotel?.rooms || []).slice().sort((a, b) => {
        if (a.id === currentlySelectedRoom) {
          return -1
        } else if (b.id === currentlySelectedRoom) {
          return 1
        } else {
          return 0
        }
      })
    },
    shouldShowPacSearchTypeInfo() {
      return false
    }
  },
  watch: {
    selectedRoom(newVal, oldVal) {
      const currentSelectedRoom = {
        roomId: newVal.toString(),
        mealPlan: this.mealPlanSelected,
        rateType: this.rateSelected,
        selectedId: this.selectedId,
        selectedRoomCode: this.selectedRates[newVal - 1]?.code || null
      }
      this.udpateSelectedRoom(currentSelectedRoom)
      if (newVal === 1) {
        this.applyFilter(this.filter.selectOccupancyIds('1'))
      } else {
        this.applyFilter(
          this.filter.selectOccupancyIds(
            newVal.toString(),
            this.mealPlanSelected,
            this.rateSelected
          )
        )
      }
      this.clearFilter()
    },
    customer() {
      this.setNonTravelAgentLabels()
      this.setBlackoutLabels()
    },
    labelsLoaded() {
      this.setNonTravelAgentLabels()
    }
  },
  created() {
    const reset = () => {
      this.selectedRates = []
      this.selectedRoom = 1
      this.mealPlanSelected = ''
      this.rateSelected = ''
      this.selectedId = null
      this.hasRateAndMealPlanSelected = false
      this.mealPlanName = ''
      this.rateName = ''
      this.fullClearFilter()
      const currentSelectedRoom = {
        roomId: null,
        mealPlan: null,
        rateType: null,
        selectedId: null
      }
      this.udpateSelectedRoom(currentSelectedRoom)
    }
    global.$(window).on('auth.postlogged', reset)
    global.$(window).on('auth.nologged', reset)
    this.$root.$on('bv::modal::show', ({ componentId }, params) => {
      global.flowSingleStep.step1.load({
        closeHandler: () => {
          this.$bvModal.hide(componentId)
        }
      })
      // global.stackAction(componentId, () => {
      //   this.$bvModal.hide(componentId)
      // })
    })
    this.$root.$on('bv::modal::hide', ({ componentId }, params) => {
      global.flowSingleStep.step1.forceBack()
      // global.unstackAction(componentId)
      global.dispatchEvent(new Event('destoy-embedded-gallery-viewer'))
    })

    this.$root.$on('changeCurrency', currency => {
      // emit event from anywhere to hot reload currencies in RD
      // example:
      /*
      roomDisplayVue.$emit('changeCurrency', {
        code: 'USD',
        name: 'US Dollar',
        exchangeRate: 1.32100396
      })
      */
      this.changeCurrencyWidget = true
      this.changeCurrency(currency)
    })

    $('footer').removeClass('d-none')
  },
  async mounted() {
    this.$store.commit('setQubitTracker', global.Cookie.read('_qubitTracker'))
    const observerQubitTracker = setInterval(() => {
      if (this.$store.getters.getQubitTracker !== global.Cookie.read('_qubitTracker')) {
        global.Cookie.set('_qubitTracker', this.$store.getters.getQubitTracker, {
          domain: '.radissonhotels.com',
          expires: global.Dates.parseDaysFromTodayToTimestamp(365)
        })
      }
      setTimeout(() => clearInterval(observerQubitTracker), 15000)
    }, 500)
    const { checkInDate, checkOutDate } = getQueryParams(
      window.location._search || window.location.search
    )
    if (checkInDate && checkOutDate && !checkDate(checkInDate, checkOutDate)) {
      this.showError({
        type: global.ProblemTypes.invalidDates,
        title: global.errorLabels.invalidDatesSelected,
        detail: 'Invalid dates selected',
        status: 400
      })
    } else {
      this.listenToCustomerChanges()
      await this.loadFirstTime()
      if (this.hotel && !this.hotel.isExternal) {
        this.getNearbyHotels()
      }
    }
    const isEnabledIgnoreReservation = global.ConfigDynamic.isEnabled({
      key: 'booking.ignore.reservation'
    })
    if (isEnabledIgnoreReservation) {
      const prebookingId = sessionStorage.getItem('prebookingId')
      if (prebookingId) {
        bookingService.appliedBookingIgnore(prebookingId)
        sessionStorage.removeItem('prebookingId')
      }
    }
  },
  updated() {
    if (this.changeCurrencyWidget) {
      $(window).trigger('userCurrencyChangeOnEnd')
      this.changeCurrencyWidget = false
    }
    this.hotel && this.hotelInformationToLocalStorage()
  },
  methods: {
    ...mapActions(Object.keys(actions)),
    onPointsClick(option) {
      this.onClearFilter()
      this.onSelectFilter(option)
      this.setFocusOnFirstStay()
      this.scrollIntoViewFirstStay()
    },
    scrollIntoViewFirstStay() {
      setTimeout(() => {
        const FIRST_STAY_ELEMENT = document.querySelector('.stay')
        const Y_OFFSET = -100 // stop 100px before element top
        var yPos = FIRST_STAY_ELEMENT.getBoundingClientRect().top + window.pageYOffset + Y_OFFSET
        window.scrollTo({ top: yPos, behavior: 'smooth' })
      }, 0)
    },
    getAnimationStyle(index) {
      return {
        animationDelay: `${index * 0.6}s`
      }
    },
    setFocusOnFirstStay() {
      setTimeout(() => {
        const FIRST_STAY_ELEMENT_FOCUSABLE = document.querySelector('.stay .stay__link')
        FIRST_STAY_ELEMENT_FOCUSABLE.focus({
          preventScroll: true
        })
      }, 0)
    },
    isSelectedRoom(room) {
      const currentIndex = this.selectedRoom - 1
      return this.selectedRates[currentIndex] && this.selectedRates[currentIndex].code === room.id
    },
    onSelectFilter(option) {
      this.selectFilterOption(option)
    },
    onUnselectFilter(option) {
      this.unselectFilterOption(option)
    },
    onClearFilter() {
      this.clearFilter()
    },
    onChangeFilter(newFilter) {
      this.applyFilter(newFilter)
    },
    onSelectStay(stay) {
      this.preBooking(stay)
    },
    onCheckHotelAvailability(hotel) {
      const { searchType, promotionCode } = ExternalStorage.url.params
      if (
        searchType === 'pac' &&
        promotionCode &&
        ['SPENDGP', 'REDEEMGP'].includes(promotionCode.toUpperCase())
      ) {
        global.searchBarVue.$emit('showSaverCalendar', {
          specialRate: searchType,
          promotionCode,
          hotelCode: hotel.code,
          origin: global.configDynamicKey.CALENDAR_SAVER_RD.origin
        })
      } else if (
        (this.hotel.matchesSearch && !this.hotel.searchApplicable) ||
        (!this.hotel.matchesSearch &&
          !this.hotel.searchApplicable &&
          this.filteredHotel.rooms.length === 0)
      ) {
        const currentDate = new Date()
        const formattedDate = currentDate.toISOString().split('T')[0]
        const offersData = {
          onlyMembers: window.Cookie.read('auth') || false,
          started: true,
          reservationStartDate: formattedDate,
          hotelCode: hotel.code,
          hotelName: hotel.name,
          minimumNights: hotel.minNightsPerStay || 1,
          hotelCodes: [hotel.code]
        }
        global.searchBarVue.$emit('showPriceCalendar', offersData)
      } else {
        // patch for integrate with searchBar
        global.selectedHotel = {
          name: hotel.name,
          code: hotel.code,
          openingDate: hotel.jsonHotel() && hotel.jsonHotel().upcomingDate
        }
        const modalOptions = {
          minNightsPerStay: hotel.minNightsPerStay
        }
        global.searchBarVue.$emit('open-searchbar-modal', modalOptions)
      }
    },
    isMinLOS() {
      const { checkInDate, checkOutDate } = getQueryParams(
        window.location._search || window.location.search
      )
      return isMinNightsStay(checkInDate, checkOutDate, this.hotel.minNightsPerStay)
    },
    onSignIn() {
      this.$root.$emit('bv::hide::modal', 'modal-loyalty-consent')
      global.$('#modal-rewards-login').modal('show')
    },
    onBookAndJoin() {
      this.acceptLoyaltyContent()
      this.$root.$emit('bv::hide::modal', 'modal-loyalty-consent')
      ExternalStorage.cookies.acceptLoyaltyConsent()
      global.trackingService.track(
        global.trackingService.eventBuilder(global.trackingEvents.CLICK_BOOK_AND_JOIN, {}),
        undefined,
        () => {
          // eslint-disable-next-line no-console
          console.log('Analytics event: ' + global.trackingEvents.CLICK_BOOK_AND_JOIN.tealium_event)
        }
      )
    },
    onInsufficientPointsModalAccept() {
      this.unselectPointsFilter()
    },
    labelForInvalidSpecialSearchType() {
      const { checkInDate, checkOutDate } = getQueryParams(
        window.location._search || window.location.search
      )
      const { searchType } = ExternalStorage.url.params
      if (
        searchType === 'pac' &&
        isMinNightsStay(checkInDate, checkOutDate, this.hotel.minNightsPerStay)
      ) {
        return this.translate(
          'rdSpecialRateNotAvailableByMinNight',
          undefined,
          this.hotel.minNightsPerStay
        )
      } else {
        return this.translate('rdSpecialRateNotAvailable')
      }
    },
    specialSearchTypeIsNotApplied() {
      const { searchType } = ExternalStorage.url.params
      return (
        searchType !== SearchTypes.LOWEST &&
        this.hotel &&
        this.hotel.matchesSearch !== undefined &&
        !this.hotel.matchesSearch &&
        !this.pacCodeSearchTypeIsNotAvailableDates() &&
        !this.pacCodeSearchTypeIsNotApplied()
      )
    },
    pacCodeSearchTypeIsNotAvailableDates() {
      const { searchType } = ExternalStorage.url.params
      return (
        searchType === SearchTypes.PAC &&
        this.hotel &&
        this.hotel.matchesSearch !== undefined &&
        !this.hotel.matchesSearch &&
        this.hotel.searchApplicable &&
        this.filteredHotel.rooms.length > 0
      )
    },
    pacCodeSearchTypeIsNotApplied() {
      const { searchType } = ExternalStorage.url.params
      return (
        searchType === SearchTypes.PAC &&
        this.hotel &&
        this.hotel.matchesSearch !== undefined &&
        !this.hotel.matchesSearch &&
        this.filteredHotel.rooms.length > 0
      )
    },
    pacCodeSearchTypeIstApplied() {
      const { searchType } = ExternalStorage.url.params
      return (
        searchType === SearchTypes.PAC &&
        this.hotel &&
        this.hotel.matchesSearch &&
        this.filteredHotel.rooms.length > 0
      )
    },
    isPayWithPointsAvailable() {
      return this.customer?.isLogged && this.hotel.hasOnlyPointsRooms(this.customer.points)
    },
    isPayWithPointsAndCashAvailable() {
      return this.customer?.isLogged && this.hotel.hasCashAndPointsRooms(this.customer.points)
    },
    hotelInformationToLocalStorage() {
      ExternalStorage.local.hotelInformation(this.hotel)
    },
    setNonTravelAgentLabels() {
      if (this.customer?.isLogged) {
        this.content = this.translate('rdProfesionalRateSelectedDescription')
        this.buttonText = this.translate('rdChangeAccount')
      } else {
        this.content = this.translate('rdTravelAgentLogInToContinue')
        this.buttonText = this.translate('rdTravelAgentLogIn')
      }
    },
    setBlackoutLabels() {
      this.blackoutText = blackoutLabelFromMemberType(this.customer, this.translate)
    },
    onViewAllStays() {
      this.isLoading = true
      ExternalStorage.url.setParams('promotionCode', '')
      ExternalStorage.url.setParams('searchType', 'lowest')
      window.location.reload()
    },
    isWebRedesign() {
      return (
        global.ConfigDynamic?.isEnabled({ key: 'web.redesign.0' }) &&
        global.ConfigDynamic?.isEnabled({ key: 'web.redesign.1' })
      )
    },
    hasNotificationMessages(messages) {
      return messages.filter(message => message?.text?.trim() !== '')?.length > 0
    },
    updateCurrentRoom(newRoom) {
      this.selectedRoom = newRoom
    },
    handleRoomSelected(
      roomSelected,
      rates,
      code,
      mealPlan,
      rate,
      mealPlanName,
      rateName,
      dealOfTheDay
    ) {
      if (this.selectedRoom === 1) {
        this.mealPlanSelected = mealPlan
        this.rateSelected = rate
        this.selectedId = rates[0].id
        this.hasRateAndMealPlanSelected = true
        this.mealPlanName = mealPlanName
        this.rateName = rateName
      }

      if (this.selectedRoom === 1 && this.selectedRoom < this.selectedRates?.length) {
        this.updateRemainingRooms([...this.initialNumberOfRoomsLeftByRoomId])
        this.selectedRates = this.selectedRates.slice(0, this.selectedRoom)
      }

      if (roomSelected) {
        const preSelectedCode = this.selectedRates?.map(e => e.code)
        const currentNumberOfRoomLeftByRoomId = [...this.numberOfRoomsLeftByRoomId]
        const preSelectedRoomIndex = currentNumberOfRoomLeftByRoomId.findIndex(
          room => room.id === preSelectedCode[this.selectedRoom - 1]
        )
        if (this.selectedRoom !== 1 && preSelectedRoomIndex !== -1) {
          currentNumberOfRoomLeftByRoomId[preSelectedRoomIndex] = {
            ...currentNumberOfRoomLeftByRoomId[preSelectedRoomIndex],
            numberOfRoomsLeft:
              currentNumberOfRoomLeftByRoomId[preSelectedRoomIndex].numberOfRoomsLeft + 1
          }
          this.updateRemainingRooms(currentNumberOfRoomLeftByRoomId)
        }
        this.selectedRoomChange = roomSelected

        const selectedRoomId = code

        const updatedRoomsLeft = [...this.numberOfRoomsLeftByRoomId]

        const roomIndex = updatedRoomsLeft.findIndex(room => room.id === selectedRoomId)

        if (roomIndex !== -1 && updatedRoomsLeft[roomIndex].numberOfRoomsLeft > 0) {
          updatedRoomsLeft[roomIndex] = {
            ...updatedRoomsLeft[roomIndex],
            numberOfRoomsLeft: updatedRoomsLeft[roomIndex].numberOfRoomsLeft - 1
          }
        }
        this.updateRemainingRooms(updatedRoomsLeft)

        if (this.rooms > 1) {
          if (!this.isLastRoomTab) {
            const roomTabsDiv = document.getElementsByClassName('room-tabs')
            const offset = 60 // Adjust this value for the desired offset
            const elementPosition = roomTabsDiv[0].getBoundingClientRect().top + window.pageYOffset

            window.scrollTo({
              top: elementPosition - offset,
              behavior: 'smooth'
            })
          }
        }
      }

      this.selectedRates[this.selectedRoom - 1] = { rates, code }

      if (dealOfTheDay !== null) {
        this.selectedRates[this.selectedRoom - 1].dealOfTheDay = dealOfTheDay
      }
      if (this.isLastRoomTab) {
        this.occupancyByRooms.forEach((occupancy, index) => {
          if (this.selectedRates[index]) {
            this.selectedRates[index] = {
              ...this.selectedRates[index],
              occupancy: occupancy
            }
          } else {
            this.selectedRates[index] = {
              rates: [],
              occupancy: occupancy,
              code: ''
            }
          }
        })
      }

      if (this.selectedRoom !== 1 && this.selectedRoom < this.selectedRates?.length) {
        this.selectedRoom = this.selectedRates?.length
      }
    }
  }
}
</script>

<style scoped lang="scss">
.rd-view {
  &__topbar {
    display: none;
    background: white;
    padding-top: 2rem;
    padding-bottom: 2rem;
    box-shadow: 0 0.5rem 1rem color('box-shadow');

    @media (min-width: 992px) {
      display: block;
    }
  }

  &__topbar-filters {
    max-width: 1140px;
    margin: auto;
    display: flex;
    justify-content: space-between;

    @media (min-width: 992px) {
      padding: 0 2.5rem;
    }
  }

  &__fixed-bar {
    display: flex;
    justify-content: center;

    @media (min-width: 992px) {
      display: none;
    }
  }

  &__info {
    display: none;
    padding-top: 3rem;
    @media (min-width: 992px) {
      display: block;
      max-width: 1440px;
      margin: auto;
      padding: 3rem 2.5rem 0 2.5rem;
    }
  }

  &__reward-message {
    display: block;
    @media (min-width: 992px) {
      max-width: 1140px;
      margin: auto;
      padding: 1rem 2.5rem 0 2.5rem;
    }
  }

  &__invalid-special-search-type {
    margin: 0;
    @media (min-width: 992px) {
      max-width: 1440px;
      margin: 2.4rem auto 0 auto;
      padding: 0 4.8rem;
    }
  }

  &__invalid-pac-search-type-dates,
  &__info-pac-search-type {
    margin: 0;
    @media (min-width: 992px) {
      max-width: 1400px;
      margin: 3rem auto 3rem auto;
      padding: 0 2.5rem;
    }
  }

  &__preselected-filter-not-matches {
    margin: 0;
    @media (min-width: 992px) {
      max-width: 1140px;
      margin: 3rem auto 3rem auto;
      padding: 0 2.5rem;
    }
  }

  &__main-content {
    display: flex;
    flex-wrap: wrap;
    @media (min-width: 992px) {
      flex-wrap: nowrap;
      max-width: 1140px;
      margin: auto;
      margin-top: 3rem;
      padding: 0 2.5rem;
    }
  }

  &__left-side {
    min-width: 100%;
    @media (min-width: 992px) {
      min-width: 310px;
      width: 310px;
      padding-inline-end: 0.75rem;
    }
  }

  &__right-side {
    min-width: 100%;
    @media (min-width: 992px) {
      min-width: percentage(8.5/12);
      width: 100%;
      padding: initial !important;
    }
  }

  &__tripadvisor {
    display: none;
    @media (min-width: 992px) {
      display: block;
    }
  }

  &__room-cards {
    margin: 0 1rem 2rem;

    &:first-child {
      margin-top: 2rem;
    }

    @media (min-width: 992px) {
      margin: 0 0 2rem 0;

      &:first-child {
        margin-top: 0;
      }
    }
  }

  &__no-availability-dates {
    min-width: 100%;
    border-top: solid 1px #e2e2e2;
    @media (min-width: 992px) {
      border: 0;
    }
  }

  &__nearby-hotels {
    width: 100%;
    display: block;
  }

  &__banners {
    display: flex;
    justify-content: space-between;
    padding-bottom: 0px !important;
    padding-top: 0px !important;
  }
}
.rd-view__room-card {
  opacity: 0;
  animation: fadeIn 0.6s ease-in forwards;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.rhg-m-width {
  max-width: 1440px;
  @media (min-width: 992px) {
    padding: 24px 48px;
  }
}

.rhg-rd-p-0 {
  padding: 0px !important;
}

.rhg-my-0 {
  margin-top: initial;
  margin-bottom: initial;
}

.rhg-mb-8 {
  margin-bottom: 8px;
}

html[dir='rtl'] {
  .rd-view {
    &__topbar-filters {
      padding: 0 3rem;
    }
  }
}
</style>
